import { regexStringBuild } from "./regexStringBuild.js";
// builds a regular expression given a regex string, flags (including the 'x' flag which allows comments and white space), and subroutines (ex. (?&thing) ).  subroutines can be used hierarchically but not recursively.
export function regexBuild(regex, flags = "", subroutines = {}) {
    // process the regex string in case it has subroutines and/or uses the x flag since javascript doesn't support these features
    regex = regexStringBuild(regex, flags, subroutines);
    // if the 'x' flag was passed remove it from flags before sending to the javascript RegExp function (else it'll throw an error for an unsupported flag)
    if (flags.indexOf('x') >= 0) {
        // remove 'x' from flags
        flags = flags.replace('x', '');
    }
    return new RegExp(regex, flags);
}
//# sourceMappingURL=regexBuild.js.map